/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'

import { get } from 'utils/lodash'

const getInitialState = () => ({
  isOpen: false,
  isConfirmCloseDialogOpen: false,
  isSelectDateDialogOpen: false,
  routesById: {},
  fitBounds: true,
  rows: [],
  originalRouteSequenceLine: {},
  routeSequenceLine: {},
  routeStopMarkers: [],
  containerCountByWorkOrder: {},
  containerSummariesById: {},
  // The full set of containers each work order references. Some never come back as
  // map markers, and that difference is what the scope list reports as unreachable.
  containerIdsByWorkOrderId: {},
  selectionDetails: { id: '', latitude: '', longitude: '' },
  isDriverPathActive: true,
  isSequenceLineActive: false,
  isStopsVisible: true,
  isContainersVisible: true,
  // Off by default: one line per container reads as a rendering artifact on a
  // dense route, and the container's own stop is already reachable by hover.
  isContainerTetherActive: false,
  routeDailyGeoJsonId: '',
  breadcrumb: [],
})

const bulkChangeContainerLocationSlice = createSlice({
  name: 'bulkChangeContainerLocation',
  initialState: getInitialState(),
  reducers: {
    setBulkChangeContainerLocationState: (state, action) => {
      return { ...state, ...action.payload }
    },
    setIsDriverPathActive: (state, action) => {
      state.isDriverPathActive = action.payload
    },
    setIsSequenceLineActive: (state, action) => {
      state.isSequenceLineActive = action.payload
    },
    setIsStopsVisible: (state, action) => {
      state.isStopsVisible = action.payload
    },
    setIsContainersVisible: (state, action) => {
      state.isContainersVisible = action.payload
    },
    setIsContainerTetherActive: (state, action) => {
      state.isContainerTetherActive = action.payload
    },
    setBreadcrumbState: (state, action) => {
      state.breadcrumb = action.payload
    },
  },
})
export const {
  setBulkChangeContainerLocationState,
  setIsDriverPathActive,
  setBreadcrumbState,
  setIsSequenceLineActive,
  setIsStopsVisible,
  setIsContainersVisible,
  setIsContainerTetherActive,
} = bulkChangeContainerLocationSlice.actions

export const selectIsOpenBulkChangeContainerLocationDialog = state => get(state, 'bulkChangeContainerLocation.isOpen', false)
export const selectIsSelectDateDialogOpen = state => get(state, 'bulkChangeContainerLocation.isSelectDateDialogOpen', false)
export const selectIsOpenBulkChangeContainerLocationConfirmCloseDialog = state =>
  get(state, 'bulkChangeContainerLocation.isConfirmCloseDialogOpen', false)
export const selectBulkChangeContainerLocationRoutesById = state => get(state, 'bulkChangeContainerLocation.routesById', {})
export const selectBulkChangeContainerLocationFitBounds = state => get(state, 'bulkChangeContainerLocation.fitBounds', false)

export const selectBulkChangeContainerLocationRows = state => get(state, 'bulkChangeContainerLocation.rows', [])
export const selectBulkChangeContainerLocationOriginalRouteSequenceLine = state =>
  get(state, 'bulkChangeContainerLocation.originalRouteSequenceLine', {})
export const selectBulkChangeContainerLocationRouteSequenceLine = state => get(state, 'bulkChangeContainerLocation.routeSequenceLine', {})
export const selectBulkChangeContainerLocationRouteStopMarkers = state => get(state, 'bulkChangeContainerLocation.routeStopMarkers', [])
export const selectBulkChangeContainerLocationContainerCountByWorkOrder = state =>
  get(state, 'bulkChangeContainerLocation.containerCountByWorkOrder', {})
export const selectBulkChangeContainerLocationContainerIdsByWorkOrderId = state =>
  get(state, 'bulkChangeContainerLocation.containerIdsByWorkOrderId', {})

export const selectBulkChangeContainerLocationContainerSummariesById = state =>
  get(state, 'bulkChangeContainerLocation.containerSummariesById', {})
export const selectBulkChangeContainerLocationSelectionDetails = state => get(state, 'bulkChangeContainerLocation.selectionDetails', {})
export const selectBulkChangeContainerLocationIsDriverPathActive = state =>
  get(state, 'bulkChangeContainerLocation.isDriverPathActive', false)
export const selectBulkChangeContainerLocationIsSequenceLineActive = state =>
  get(state, 'bulkChangeContainerLocation.isSequenceLineActive', false)
export const selectBulkChangeContainerLocationIsStopsVisible = state => get(state, 'bulkChangeContainerLocation.isStopsVisible', true)
export const selectBulkChangeContainerLocationIsContainersVisible = state =>
  get(state, 'bulkChangeContainerLocation.isContainersVisible', true)
export const selectBulkChangeContainerLocationIsContainerTetherActive = state =>
  get(state, 'bulkChangeContainerLocation.isContainerTetherActive', false)
export const selectBulkChangeContainerLocationRouteDailyGeoJsonId = state =>
  get(state, 'bulkChangeContainerLocation.routeDailyGeoJsonId', '')
export const selectBulkChangeContainerLocationBreadcrumb = state => get(state, 'bulkChangeContainerLocation.breadcrumb', [])

export default bulkChangeContainerLocationSlice.reducer
